"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.buildClientId = exports.ClientPlatform = exports.ClientProduct = void 0;
const interfaces_1 = require("../interfaces");
exports.ClientProduct = interfaces_1.PRODUCT_TYPE;
var ClientPlatform;
(function (ClientPlatform) {
    ClientPlatform["WEB"] = "web";
    ClientPlatform["ANDROID"] = "android";
    ClientPlatform["IOS"] = "ios";
})(ClientPlatform || (exports.ClientPlatform = ClientPlatform = {}));
function buildClientId(productType, platform, versionOrTag) {
    return `${productType.toLowerCase()}_${platform.toLowerCase()}_${versionOrTag}`;
}
exports.buildClientId = buildClientId;
